<template>
  <!-- _________________________ VALIDATE ACCOUNT _________________________ -->
  <div id="login-div">

    <b-alert :show="ui.showError" variant="danger" class="mt-5">
      {{ $t('ValidateAccount.error') }}
      <br/>
    </b-alert>

    <b-alert :show="ui.showSuccess" variant="success" class="mt-5">
      {{$t('ValidateAccount.success')}}
      <br/>
    </b-alert>

    <div class="mt-5 text-right">
      <b-link v-on:click="backToLogin" class="forgot-password-link textual-link">{{ $t('backToLoginText') }}</b-link>
    </div>

  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'ValidateAccountComponent',

  data () {
    return {
      token: this.$route.params.token,
      userId: this.$route.params.userId,
      ui: {
        showSuccess: false,
        showError: false
      }
    }
  },

  emits: ['showLoginView'],

  mounted () {
    this.validateAccount()
  },

  methods: {

    validateAccount () {
      const data = new FormData()
      data.append('token', this.token)
      data.append('userId', this.userId)

      api({
        method: 'POST',
        url: `/authentication/validateAccount`,
        data: data
      })
        .then(() => {
          this.ui.showSuccess = true
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    backToLogin () {
      this.$emit('showLoginView')
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/ValidateAccountComponent.vue